import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const carPoints = [
  // LINKS
  { id: 1, top: '4%', left: '10%', part: 'linksvoor' },
  { id: 2, top: '25%', left: '22%', part: 'spatbord_linksvoor' },
  { id: 3, top: '25%', left: '10%', part: 'wiel_linksvoor' },
  { id: 4, top: '40%', left: '28%', part: 'spiegel_links' },
  { id: 5, top: '43%', left: '20%', part: 'deur_linksvoor' },
  { id: 6, top: '50%', left: '7%', part: 'dorpel_links' },
  { id: 7, top: '52%', left: '37%', part: 'linker_dakstijl' },
  { id: 8, top: '55%', left: '20%', part: 'deur_linksachter' },
  { id: 10, top: '70%', left: '10%', part: 'wiel_linksachter' },
  { id: 11, top: '75%', left: '24%', part: 'spatbord_linksachter' },
  { id: 12, top: '96%', left: '10%', part: 'linksachter' },
  // { id: 13, top: '90%', left: '18%', part: 'laaddeur_linksachter' },

  // CENTRAAL
  { id: 14, top: '0%', left: '50%', part: 'voorzijde' },
  { id: 15, top: '11%', left: '34%', part: 'koplamp_links' },
  { id: 16, top: '11%', left: '66%', part: 'koplamp_rechts' },
  { id: 17, top: '6%', left: '50%', part: 'bumper_voor' },
  { id: 18, top: '20%', left: '50%', part: 'motorkap' },
  { id: 19, top: '12%', left: '50%', part: 'grille' },
  { id: 20, top: '38%', left: '50%', part: 'voorruit' },
  { id: 21, top: '56%', left: '50%', part: 'dak' },
  { id: 22, top: '49%', left: '50%', part: 'panoramadak' },
  // { id: 23, top: '62%', left: '50%', part: 'rondom' }, //andere afbeelding gebruiken
  { id: 24, top: '73%', left: '50%', part: 'achterruit' },
  { id: 25, top: '81%', left: '50%', part: 'kofferklep' },
  { id: 26, top: '100%', left: '50%', part: 'achterzijde' },
  { id: 27, top: '93%', left: '50%', part: 'bumper_achter' },
  { id: 28, top: '88%', left: '35%', part: 'achterlicht_links' },
  { id: 29, top: '88%', left: '65%', part: 'achterlicht_rechts' },
  // { id: 30, top: '95%', left: '40%', part: 'deur_achter' },

  // RECHTS
  { id: 31, top: '4%', left: '90%', part: 'rechtsvoor' },
  { id: 32, top: '25%', left: '78%', part: 'spatbord_rechtsvoor' },
  { id: 33, top: '25%', left: '90%', part: 'wiel_rechtsvoor' },
  { id: 34, top: '40%', left: '72%', part: 'spiegel_rechts' },
  { id: 35, top: '43%', left: '80%', part: 'deur_rechtsvoor' },
  { id: 36, top: '50%', left: '93%', part: 'dorpel_rechts' },
  { id: 37, top: '52%', left: '64%', part: 'rechter_dakstijl' },
  { id: 38, top: '55%', left: '80%', part: 'deur_rechtsachter' },
  // { id: 39, top: '71%', left: '82%', part: 'schuifdeur_rechts' },
  { id: 40, top: '70%', left: '90%', part: 'wiel_rechtsachter' },
  { id: 41, top: '75%', left: '77%', part: 'spatbord_rechtsachter' },
  { id: 42, top: '96%', left: '90%', part: 'rechtsachter' },
  // { id: 43, top: '90%', left: '82%', part: 'laaddeur_rechtsachter' },
];

const Wrapper = styled.div`
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin: 0;
  margin-top: 30px;
  margin-bottom: 30px;
  aspect-ratio: 480 / 766;
  background-color: #f5f5f5; 
`;

const CarImageContainer = styled.div`
  width: 100%;
  padding-bottom: 100%; 
  position: relative;
  background-image: url('https://vindat.indewal.nl/storage/documents/bdf5f407-692d-4ebf-b218-40170d65797b.png');
  background-size: contain;
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
`;

const Marker = styled.img`
  position: absolute;
  width: 26px;
  height: 26px;
  cursor: pointer;
  transform: translate(-50%, -50%);
  transition: all 0.2s ease;

  &:hover {
    transform: translate(-50%, -50%) scale(1.1);
  }
`;

export const CarExteriorIncidentsInteractive_big = function({ vehicle, onPartClick }) {
  const [selectedPart, setSelectedPart] = useState(null);
  const [containerSize, setContainerSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const handleResize = () => {
      const container = document.querySelector('[data-car-container]');
      if (container) {
        setContainerSize({
          width: container.offsetWidth,
          height: container.offsetHeight,
        });
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleClick = (id, part) => {
    console.log(`Button ${id}-${part} clicked!`);
    setSelectedPart(part);
    onPartClick(part);
  };

  return (
    <Wrapper>
      <CarImageContainer data-car-container>
        {vehicle?.exterior_damage_free !== '1' &&
          carPoints.map(point => (
            <Marker
              key={point.id}
              style={{
                top: point.top,
                left: point.left,
              }}
              src={
                selectedPart === point.part
                  ? point.part === 'rondom'
                    ? '/public/images/icon_selected_rondom.png'
                    : '/public/images/icon_selected.png'
                  : point.part === 'rondom'
                  ? '/public/images/icon_rondom.png'
                  : '/public/images/icon_incident.png'
              }
              onClick={() => handleClick(point.id, point.part)}
              alt={`Marker for ${point.part}`}
            />
          ))}
      </CarImageContainer>
    </Wrapper>
  );
};
